import { render, staticRenderFns } from "./AvexCoachDetail.vue?vue&type=template&id=a355f8e0&scoped=true&lang=pug"
import script from "./AvexCoachDetail.vue?vue&type=script&lang=js"
export * from "./AvexCoachDetail.vue?vue&type=script&lang=js"
import style0 from "./AvexCoachDetail.vue?vue&type=style&index=0&id=a355f8e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a355f8e0",
  null
  
)

export default component.exports